export function download(url: string, extension: string, mimeType: string, suggestedName?: string) {

    if('showSaveFilePicker' in window) {
        return downloadFSAPI(url, extension, mimeType, suggestedName);
    } else {
        return downloadLegacy(url, extension, suggestedName);
    }
}

async function downloadFSAPI(url: string, extension: string, mimeType: string, suggestedName?: string) {
    const response = await fetch(url);
    const blob = await response.blob();
    // @ts-expect-error
    const handle = await window.showSaveFilePicker({
        suggestedName: suggestedName ?? url.split('/').pop(),
        accept: { [mimeType]: [`.${extension}`] }
    });
    const writable = await handle.createWritable();
    await writable.write(blob);
    await writable.close();
}

// adapted from https://yon.fun/download-file-js/
async function downloadLegacy(url: string, extension: string, suggestedName?: string) {
    const response = await fetch(url);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = blobUrl;
    anchor.target = "_blank";
    anchor.download = suggestedName ?? url.split('/').pop() ?? `download.${extension}`;
  
    // Auto click on a element, trigger the file download
    anchor.click();
      
    // clean up
    URL.revokeObjectURL(blobUrl);
    anchor.remove();
}

export function printURL(url: string) {
    const pdfWindow = window.open(url, '_blank');
    if(pdfWindow) {
        pdfWindow.focus();
        pdfWindow.print();
    }
}